import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';

import { Credit } from '@types';
import { IProfileProgress, userHttp } from '@network';
import { InitialCard, InitialRow } from '@components';
import { ProfileProgress } from '@pages/user/UserEdit/ProfileProgress';
import { rbac } from '@utils';

export const CreditUser = ({ credit }: {credit: Credit}) => {
  const user = credit.user;
  const locations = user.location;
  const [firstLocation] = locations || [];
  const cls = useStyles();

  const [profileProgress, setProfileProgress] = useState<IProfileProgress | null>(null);

  useEffect(() => {
    if (user) {
      (async () => {
        const res = await userHttp.getProfileProgress(user.id);
        setProfileProgress(res);
      })();
    }
  }, [user]);

  const phone = rbac.canShowUserPhone() ? user.phone : '*'.repeat(`${user.phone}`.length);

  return (
    <InitialCard left="User" autoHeight extraPadding>
      <div className={cls.box}>
        <InitialRow title="Accredited:">{credit.accreditedName}</InitialRow>
        <InitialRow title="Phone:">{phone}</InitialRow>
        <InitialRow title="State:">{user.state?.name || '–'}</InitialRow>
        <InitialRow title="City:">{firstLocation?.city || '–'}</InitialRow>
        <InitialRow title="CIEC:">{user.ciecHidden || '–'}</InitialRow>
        <InitialRow title="Responsible Manager:">{user.responsibleAdmin?.name || '–'}</InitialRow>
        <Link to={`/user/${user.id}`}>
          <div className={cls.progress}>
            <ProfileProgress profileProgress={profileProgress} />
          </div>
        </Link>
      </div>
    </InitialCard>
  );
};

const useStyles = makeStyles({
  box: {
    marginTop: 15,
    fontFamily: 'var(--font-primary)',
    color: 'var(--text-color)',
  },
  btn: {
    padding: '0',
    width: 32,
    height: 32,
    marginLeft: 12,
  },
  progress: {
    marginTop: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
